module.exports = __webpack_public_path__ + "29e6137880e768d804a34dc163daae61.png";